<template>
	<Pie
		v-if="chartdata && chartdata.datasets && chartdata.datasets.length > 0"
		:chart-data="chartdata"
		:chart-options="options"
		:style="$attrs.style"
	/>
</template>

<script>
	import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
	import { Pie } from "vue-chartjs";

	ChartJS.register(ArcElement, Tooltip, Legend);

	export default {
		name: "PieChart",
		components: {
			Pie,
		},
		props: {
			chartdata: {
				type: Object,
				default: null,
			},
			options: {
				type: Object,
				default: () => ({}),
			},
		},
	};
</script>
